var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"grid dropdown-layout"},_vm._l((_vm.dropdownOptions),function(d){return _c('dropdown-component',{key:d.id,attrs:{"title":d.title,"description":d.description,"options":d.options},on:{"change":(e) => _vm.addToAnswers(d.id, e)}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }